/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { ref, onMounted, createApp, nextTick, watch, reactive } from "vue";
import Tabs from "@/class/Tabs";

export default function usePopup(id: string, pID: string) {
  let content = ref("");
  let articleID = ref("");
  let title = ref("");
  let show = ref(false);
  let pos = reactive({ x: 0, y: 0 });

  watch(
    () => {
      return articleID.value;
    },
    (state, preState) => {
      if (!state) {
        show.value = false;
        return false;
      }
      show.value = true;

      fetchContent();
    }
  );

  onMounted(() => {
    var testUl = document.getElementById("layout-article");

    testUl!.addEventListener("click", function (event) {
      var ev = event || window.event;

      pos.x = ev.pageX;
      pos.y = 10;

      var target = ev.target as HTMLInputElement;
      let domPopupID = target!.getAttribute("data-popup") as string;

      if (domPopupID == articleID.value) {
        return false;
      }
      articleID.value = domPopupID || "";

      // while (target !== oUl) {
      //   if (target.nodeName.toLowerCase() == "li") {
      //     console.log("click li");
      //     break;
      //   }
      //   target = target.parentNode;
      // }
    });
  });

  function fetchContent() {
    jsonp("https://news-my.web.sdo.com/UniInterface/news/newscontent.asp", {
      Article: articleID.value, ApplicationCode: "20",
      Type: "json",
    }).then((res: any) => {
      content.value = res.Content;
      title.value = res.Title;
      nextTick(() => { });
    });
  }

  articleID.value = id;

  return { content, title, show, pos };
}
